var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 3C9.72271 3 7.7 5.02271 7.7 7.5C7.7 9.97729 9.72271 12 12.2 12C14.6773 12 16.7 9.97729 16.7 7.5C16.7 5.02271 14.6773 3 12.2 3ZM12.2 4.35C13.9477 4.35 15.35 5.75231 15.35 7.5C15.35 9.24769 13.9477 10.65 12.2 10.65C10.4523 10.65 9.05 9.24769 9.05 7.5C9.05 5.75231 10.4523 4.35 12.2 4.35ZM6.79033 13.8C5.80942 13.8 5 14.6094 5 15.5903V16.275C5 17.8969 6.02567 19.1515 7.38799 19.9031C8.75031 20.6547 10.4756 21 12.2 21C13.9244 21 15.6497 20.6547 17.012 19.9031C18.1736 19.2623 19.0478 18.2382 19.2928 16.95H19.4009V15.5903C19.4009 14.6094 18.5906 13.8 17.6097 13.8H6.79033ZM6.79033 15.15H17.6097C17.8609 15.15 18.0509 15.3391 18.0509 15.5903V15.6H18.05V16.275C18.05 17.3531 17.4444 18.1235 16.3599 18.7219C15.2753 19.3203 13.7381 19.65 12.2 19.65C10.6619 19.65 9.1247 19.3203 8.04014 18.7219C6.95558 18.1235 6.35 17.3531 6.35 16.275V15.5903C6.35 15.3391 6.53915 15.15 6.79033 15.15Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.f995192c927509e956049c0f20059ef9.svg";
export { ForwardRef as ReactComponent };